<template>
  <div>
    <hr />
    <div class="form-row">
      <div class="form-group col-md-12">
        <label>
          Deposit Amount: {{depositText}}
        </label>
      </div>
    </div>
    <div class="form-row">
      <div class="form-group col-md-12">
        <label for="Card Holder Name">Card Holder Name</label>
        <input
          v-validate="'required'"
          id="cardHolder"
          v-model="editModel.CardHolder"
          name="Card Holder Name"
          type="text"
          class="form-control"
        />
        <span class="required">
          {{ OOErrors.first("Card Holder Name") }}
          <i
            v-if="OOErrors.first('Card Holder Name')"
            class="fa fa-info-circle"
          ></i>
        </span>
      </div>
    </div>
    <div class="form-row">
      <div class="form-group col-md-5">
        <label for="Card Number">Card Number</label>
        <input
          v-validate="'required|credit_card'"
          id="cardinput"
          v-model="editModel.CardNumber"
          name="Card Number"
          type="text"
          class="form-control"
          maxlength="16"
        />
        <span class="required">
          {{ OOErrors.first("Card Number") }}
          <i
            v-if="OOErrors.first('Card Number')"
            class="fa fa-info-circle"
          ></i>
        </span>
      </div>
      <div class="form-group col-md-5">
        <label for="Expiry Date">Expiry Date</label>
        <input
          v-validate="{ required: true, regex: /^((0[1-9])|([1-9])|(1[012]))\/((201[19])|(202[0-9]))$/ }"
          id="exInput"
          v-model.trim="editModel.ExpireDate"
          type="text"
          name="Expiry Date"
          class="form-control"
          placeholder="MM/YYYY"
        />
        <span class="required">
          {{ OOErrors.first("Expiry Date") }}
          <i
            v-if="OOErrors.first('Expiry Date')"
            class="fa fa-info-circle"
          ></i>
        </span>
      </div>
      <div class="form-group col-md-2">
        <label for="CVV">CVV</label>
        <input
          v-validate="{ required: true, regex: /^[0-9]{3,4}$/ }"
          id="CVV"
          v-model="editModel.CVV"
          name="CVV"
          type="text"
          class="form-control"
          placeholder="111"
        />
        <span class="required">
          {{ OOErrors.first("CVV") }}
          <i v-if="OOErrors.first('CVV')" class="fa fa-info-circle"></i>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "card-component",
  props: {
    editModel: {
      type: Object,
      default: () => {}
    },
    reservationInfo: {
      type: Object,
      default: function() {
        return {
          numberOfGuests: 1,
          venueInfo: { DepositPerGuest: 0 }
        };
      }
    }
  },
  data() {
    return {
      cardType: "master"
    };
  },
  computed: {
    depositAmount() {
      return this.editModel.Amount;
    },
    depositText() {
      const postfix = this.reservationInfo.numberOfGuests > 1 ? '(s)' : '';
      const label = this.reservationInfo.venueInfo
        && this.reservationInfo.venueInfo.GuestLabelOverride
        ? this.reservationInfo.venueInfo.GuestLabelOverride.concat(postfix)
        : 'People';
      return '$'.concat(
        this.fix2digit(this.depositAmount),
        ' total for ',
        this.reservationInfo.numberOfGuests,
        ' ',
        label
      );
    },
  },
  watch: {
    "reservationInfo.numberOfGuests": function() {
      this.editModel.Amount =
        this.reservationInfo.numberOfGuests *
        this.reservationInfo.venueInfo.DepositPerGuest;
    }
  },
  mounted() {
    this.editModel.Amount =
      this.reservationInfo.numberOfGuests *
      this.reservationInfo.venueInfo.DepositPerGuest;
  },
  methods: {
    validate() {
      return this.$validator.validateAll();
    },
    fix2digit(value) {
      return parseFloat(value).toFixed(2);
    }
  }
};
</script>
